/**
 * useCrispChat Hook
 * Custom hook for handling Crisp chat integration
 * Based on the old implementation from ibitplay codebase
 */

import { useState, useCallback, useRef } from 'react';
import { CRISTP_ID, addNewStyle, wait } from '@/utils';

/**
 * Hook to manage Crisp chat functionality
 * @returns {Object} Object containing loaded state and handleSupportClick function
 */
export const useCrispChat = () => {
  const [loaded, setLoaded] = useState(false);
  const closeHandlerRef = useRef(null);

  const handleSupportClick = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    console.log('Support clicked');
    
    // Initialize Crisp
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;

    if (!loaded) {
      console.log('Loading support script');
      setLoaded(true);
      
      const script = document.createElement('script');
      script.src = 'https://client.crisp.chat/l.js';
      script.id = 'chtt';
      script.async = true;
      document.head.appendChild(script);

      // Open chat after script loads
      script.onload = () => {
        window.$crisp.push(['do', 'chat:open']);
      };
    } else {
      window.$crisp.push(['do', 'chat:open']);
    }

    // Show chatbox
    addNewStyle('#crisp-chatbox {display:block !important;}');
    addNewStyle(
      '.crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}'
    );

    // Set up close button handler after delay
    wait(2000).then(() => {
      const close = document.querySelector('.cc-wdhl');
      if (close === null) return;
      
      // Remove previous handler if exists
      if (closeHandlerRef.current) {
        close.removeEventListener('click', closeHandlerRef.current);
      }
      
      // Create new handler
      closeHandlerRef.current = function (event) {
        addNewStyle('#crisp-chatbox {display:none !important;}');
        const scriptElement = document.getElementById('chtt');
        if (scriptElement) {
          scriptElement.src = '';
        }
      };
      
      close.addEventListener('click', closeHandlerRef.current);
    });
  }, [loaded]);

  return {
    loaded,
    handleSupportClick,
  };
};
